import React from 'react';
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import QRreader from '../components/qr';
import { Plugins } from '@capacitor/core';
import './Tab2.css';

const Tab2: React.FC = () => {
  const { Storage } = Plugins;

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Scanner</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Scanner</IonTitle>
          </IonToolbar>
        </IonHeader>
        <QRreader store={Storage} />
      </IonContent>
    </IonPage>
  );
};

export default Tab2;
